module.exports = __webpack_public_path__ + "img/2019-05-12.7488b68b.jpg";